<div
  class="preview-results-container"
  [ngClass]="{
    'people-preview-large': (!smallWidthPreview && size !== 'popup') || previewPopupLarge,
    'people-preview-popup-large': previewPopupLarge
  }"
>
  <div class="preview-results-header" [class.with-number]="isRelevantPeople" *ngIf="!isLoading && !isEmpty">
    <span class="preview-results-title-header">{{ isRelevantPeople ? 'Contributions' : 'Latest activities' }}</span>
    <span *ngIf="isRelevantPeople" class="preview-results-title-amount">{{ (results$ | async)?.totalResults }}</span>
  </div>
  <div #scroll_recent_activities>
    <ng-scrollbar visibility="hover" [ngClass]="{ 'preview-results-scroll-empty': isEmpty }" [style.height]="scrollHeight">
      <cdk-virtual-scroll-viewport appendOnly [itemSize]="53" scrollViewport [class.virtual-scroll]="true">
        <div @fade class="preview-results-ghost-container" *ngIf="isLoading; else content">
          <result-ghost *ngFor="let i of loadingRows | fill"></result-ghost>
        </div>
        <ng-template #content>
          <div class="preview-results-content" *ngIf="!isEmpty; else emptyState">
            <preview-result-item
              #preview_result_item
              *ngFor="let item of (results$ | async)?.items; index as i"
              [size]="size"
              [item]="{ model: item, userName: userName, userEmail: userEmail }"
              [index]="i"
              [attr.data-index]="i"
              [class.selected]="selectedIndex === i"
              [selected]="selectedIndex === i"
              [smallWidthPreview]="smallWidthPreview"
              [telemetrySearch]="telemetrySearch"
              (click)="selectedIndex = i"
              (contextOpen)="selectedIndex = i"
            >
            </preview-result-item>
          </div>
          <ng-template #emptyState>
            <app-empty-state
              data-cy="people-preview-empty-activities-text"
              class="preview-results-empty-state"
              [title]="'No latest activities yet'"
              [icon]="emptyStateIcon"
            ></app-empty-state>
          </ng-template>
        </ng-template>
      </cdk-virtual-scroll-viewport>
      <gradient-overflow *ngIf="!isLauncher && countItems && existScroll | async"></gradient-overflow>
    </ng-scrollbar>
  </div>
</div>
